import React from 'react';
import PropTypes from 'prop-types';

/* CONSTANTS */
const STEP_ACTIVE_CLASS = 'badge badge-pill bg-primary';
const STEP_INACTIVE_CLASS = 'badge badge-pill bg-secondary';
const LABEL_ACTIVE_CLASS = 'text-primary';
const LABEL_INACTIVE_CLASS = 'text-secondary';
/* styles for custom classes */

class Step extends React.Component {
	constructor(props) {
		super(props);
	}


	render() {

		let circleClass = this.props.active ? STEP_ACTIVE_CLASS : STEP_INACTIVE_CLASS;
		let labelClass = this.props.active ? LABEL_ACTIVE_CLASS : LABEL_INACTIVE_CLASS;

		return (
			<div className='Step nav-item'>
					<div className={circleClass}>
						<span className='text-white'>
							{this.props.number}
						</span>
					</div>
					<div className='text-sm-center'>
						<small className={labelClass}>
							{this.props.label}
						</small>
					</div>
			</div>
		);
	}


} /* end Step component */

Step.propTypes = {
	active: PropTypes.bool.isRequired,
	number: PropTypes.number.isRequired,
	numSteps: PropTypes.number.isRequired,
	label: PropTypes.string
};


export default class Stepper extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const stepArray = this.props.stepNames.map((stepName, i) => {
			return (
				<Step number={i+1}
					label={stepName}
					active={this.props.activeStep === i}
					completed={this.props.activeStep > i}
					numSteps={this.props.stepNames.length}
					key={i}
				/>
			);
		});

		return (
			<div id='Stepper'>
				<div className='nav nav-justified mt-4 mb-4'>
					{stepArray}
				</div>
			</div>
		);
	}
}

Stepper.propTypes = {
	stepNames: PropTypes.arrayOf(PropTypes.string).isRequired,
	activeStep: PropTypes.number.isRequired
};
